import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft } from '../ui/Icons';

export const Footer = () => {
    const location = useLocation();
    
    // Don't show footer on homepage, login, register pages
    const hiddenPaths = ['/', '/prihlaseni', '/registrace'];
    if (hiddenPaths.includes(location.pathname)) {
        return null;
    }

    // Don't show on admin pages
    if (location.pathname.startsWith('/admin')) {
        return null;
    }

    return (
        <footer className="border-t border-foreground/20 py-8">
            <div className="flex items-center justify-center gap-3">
                <span className="text-xl italic">Listovna</span>
                <ArrowLeft className="w-10 h-5 text-foreground/60" />
                <Link 
                    to="/" 
                    className="text-lg italic hover:underline underline-offset-4"
                    data-testid="footer-home"
                >
                    zpět na homepage
                </Link>
            </div>
        </footer>
    );
};
